# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://coffeescript.org/

ready = ->
  $('.datatable').not('.initialized').addClass('initialized').DataTable({
    order: [[ 1, 'desc' ]]
  })

$(document).on 'turbolinks:load', ready
